/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'positive-security-policy';

export const positiveSecurityPolicyBreadcrumbTitle = `${prefix}.positiveSecurityPolicyBreadcrumbTitle`;

export const ENGLISH = {
    [positiveSecurityPolicyBreadcrumbTitle]: 'Positive Security Policy',
};
